import React from "react";
import { useNavigate } from "react-router-dom";
const CopyrightabilityEngine: React.FC = () => {
  const navigate = useNavigate();
  
  return <div className="py-16 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
      {/* 3D Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-32 h-32 bg-tagblue/10 rounded-3xl backdrop-blur-sm rotate-12 animate-float" />
        <div className="absolute bottom-20 right-20 w-24 h-24 bg-tagblue-light/10 rounded-2xl backdrop-blur-sm -rotate-12 animate-float" style={{
        animationDelay: '2s'
      }} />
      </div>
      
      <div className="container mx-auto px-6 md:px-8 lg:px-12 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Left side - Content */}
          <div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 via-tagblue to-gray-900 mb-2 leading-relaxed py-2">
              Copyrightability Engine
            </h2>
            <p className="text-tagblue text-sm mb-6 md:text-lg">Our Flagship Product</p>
            <p className="text-gray-600 text-lg md:text-xl mb-8 leading-relaxed">Calculate human versus AI effort percentage through our DAW plugin that captures stem-wise analysis during production. Enables Intentional usage reporting by Creators & accurate overall percentage calculations during multi-track bounce:</p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-700 text-base md:text-lg">Stem-wise AI detection analysis</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-700 text-base md:text-lg">Precise percentage calculation of human vs AI effort</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                <span className="text-gray-700 text-base md:text-lg">Intentional AI usage reporting by creators</span>
              </div>
            </div>
            
            <button 
              onClick={() => navigate('/copyrightability-engine')}
              className="bg-tagblue text-white px-8 py-4 rounded-lg text-lg hover:bg-tagblue-dark transition-colors"
            >
              Learn More
            </button>
          </div>
          
          {/* Right side - Logo/Visual */}
          <div className="flex justify-end lg:justify-center xl:justify-end">
            <div className="bg-white rounded-3xl p-12 text-center shadow-lg relative">
              {/* 3D floating elements around the logos */}
              <div className="absolute -top-4 -left-4 w-8 h-8 bg-white/30 rounded-xl rotate-45 animate-float" />
              <div className="absolute -bottom-4 -right-4 w-6 h-6 bg-tagblue/30 rounded-lg -rotate-12 animate-float" style={{
              animationDelay: '1s'
            }} />
              
              {/* Top logo - Copyrightability Engine */}
              <div className="mb-3">
                <img src="/lovable-uploads/b50fbb0d-efe7-415f-93b5-09197c072993.png" alt="Copyrightability Engine" className="w-full max-w-[350px] mx-auto" />
              </div>
              
              {/* Powered by text and TAG Plugin - grouped together */}
              <div className="space-y-2">
                <p className="text-sm text-tagblue">powered by</p>
                <div>
                  <img src="/lovable-uploads/ada680f8-cd3f-430e-a101-76078a441c1e.png" alt="TAG Plugin for DAW" className="w-full max-w-[280px] mx-auto" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default CopyrightabilityEngine;